module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Medium.eot
// module id = 271
// module chunks = 0